/* eslint-disable max-len */

const BOAT_STORAGE_DATA = [
	{
		heading: "Boat Storage",
		description:
			"Boats are popular recreational vehicles for those who live near a body of water. They’re great for weekend outings, summer vacations, and fishing trips and can create lasting memories along the way.",
		description2:
			"The only downfall to owning a boat is the amount of space it takes up, especially if you don’t have your own dock. Boats can quickly consume a driveway, yard, or garage. Also, some neighborhood covenants don’t allow homeowners to store their boats at home.",
		description3:
			"Fortunately, there are many self storage facilities across the nation that offer boat storage solutions."
	},
	{
		heading: "Reasons for Using Boat Storage",
		description:
			"Several industries have found that commercial storage services offered by storage facilities can help their operations:",
		subHeadings: [
			{
				title: "Frees Up Space",
				desc: "With your boat in storage, you no longer have to maneuver around it to get into your garage or park in the street because there’s no room in your driveway. Boats average between 15 or 28 feet in length, and some can be even larger. That’s a lot of space that you could regain by utilizing boat storage."
			},
			{
				title: "Neighborhood HOAs",
				desc: "Some neighborhoods have rules in place that don’t allow you to park a boat in your driveway for aesthetic purposes. Boat storage can give you the opportunity to stay in that neighborhood without having to sell your boat."
			},
			{
				title: "Protection/Security",
				desc: "Boats can be high-profile targets for thieves and vandals, so it can be risky to leave it outside of your home. Also, the weather could potentially wreak havoc on an uncovered boat, depending on what region you live in and time of year. Boat storage can offer you the security and protection from the elements that you desire for your boat."
			},
			{
				title: "Convenient Location",
				desc: "With storage facilities located all around the country, you can find one that’s close to your home so pick-up will be as swift as possible. Sometimes, you can even find a location that’s closer to your favorite body of water than your home, so you can save on gas and time when you’re ready to hit the water."
			},
			{
				title: "Dry Storage",
				desc: "Leaving your boat in the water at a dock may be the most convenient storage option available, especially during the height of summer. But a boat that’s constantly being thrashed by water will suffer much more damage than one that’s placed in dry storage frequently. Dry boat storage is great for longer periods of time when your boat isn’t in use because it will help protect it from the abuse that water can deliver."
			},
			{
				title: "Winter Storage",
				desc: "Boat storage is great for the winter months when you can’t use your boat. If you plan on putting your boat away in storage for the winter months, it’s important to take the proper precautions. Climate-controlled indoor storage can protect your boat from the harsh winter weather and help your boat have a long, useful life."
			}
		]
	},
	{
		heading: "Types of Boat Storage",
		description:
			"Different facilities will offer different types of boat storage, so it’s important to know exactly what you’re looking for and how much you want to spend. The more protection there is for your boat, the higher the cost is going to be, but it may be worth it if it helps your boat last longer. Many of the facilities on Storage.com offer the following options for boat storage:",
		subHeadings: [
			{
				title: "Outdoor",
				desc: "Outdoor boat storage is the most affordable way to get your boat out of your driveway. It doesn’t offer any additional protection from the elements, but it is in a secured area so you don’t have to worry about theft."
			},
			{
				title: "Covered",
				desc: "Covered boat storage provides your boat with some additional protection from the elements, namely the sun. Placed under a freestanding shelter, covered boat storage typically costs more than outdoor boat storage, but it’s worth the extra protection."
			},
			{
				title: "Indoor",
				desc: "Indoor boat storage offers the most protection possible so your boat will be completely shielded from Mother Nature. While it’s the most expensive option, it can very easily extend the life of your boat."
			}
		]
	},
	{
		heading: "Importance of Security with Boat Storage",
		description:
			"It’s important to take security into consideration when placing a boat into long-term storage. Boats aren’t cheap, so most boat owners would like to know their boats are protected at all costs. Some facilities offer gated entry, video surveillance, and occasionally on-site management. Extra security may factor into the final cost of boat storage, but it’s worth it to protect a valuable piece of property."
	},
	{
		heading: "Prepping Your Boat for Storage",
		description:
			"When using outdoor or covered boat storage, it’s important that you still take the proper precautions to protect your boat from the elements. Since your boat won’t be fully protected by being inside, you’ll need to have a boat cover.",
		description2:
			"Prepping Your Boat for Storage When using outdoor or covered boat storage, it’s important that you still take the proper precautions to protect your boat from the elements. Since your boat won’t be fully protected by being inside, you’ll need to have a boat cover.",
		description3:
			"It’s recommended that you get your boat serviced before you put it away into long-term storage so you can avoid mechanical issues as well. That way, your boat will be ready for the water."
	},
	{
		heading: "Boat Storage FAQs",
		subHeadings: [
			{
				title: "Why should I use boat storage?",
				desc: "While boats are designed for use in the water, it is wise to keep them out of the water and dry whenever you’re not using them frequently. Although docking your boat somewhere means you can access it more readily, constant exposure to the elements (sunlight, water, rain, wind) will eventually fade and/or chip the paint job and could encourage rust development. Not to mention leaving the boat in the water long-term makes it more vulnerable to aquatic pests such as barnacles."
			},
			{
				title: "How do I prepare my boat for winter storage?",
				desc: "The proper steps for winterizing a boat varies from model to model, so always check your owner’s manual first. But here are some general tips."
			},
		],
		points: [
			{
				desc: "Remove excess water from your boat. This can be done by emptying the drain plugs or running antifreeze through the boat’s water systems."
			},
			{
				desc: "Apply fuel stabilizer to your fuel tank."
			},
			{
				desc: "Prepare the engine for long-term storage. For inboard motors, apply fogging spray or fogging oil to the engine. For outboard motors, leave engine in downward position so the water drains off naturally. While these are the general methods to prevent rust, be sure to check your owner’s manual for any specific instructions."
			}
		],
		subHeadings2: [
			{
				title:"Do I need a boat cover?",
				desc:"A boat cover is not required, but it will protect your boat’s surface from the elements. Constant exposure to sunlight will eventually fade the paint, and debris stirred up by the wind could eventually chip at the surface. Covering your boat will also keep out pests such as rodents and insects. You don’t want to take your boat out of storage only to find a colony of mice roosting inside."
			},
			{
				title:"What is the difference between indoor and outdoor boat storage?",
				desc:"Outdoor boat storage is the cheaper form of boat storage. You simply park your boat in an outdoor parking lot as you would an automobile. This might be the best kind of storage if you live in a mild climate and only need storage for a short time, but you still need to take precautions against protecting your boat from pests and the elements.",
				desc2:"Indoor boat storage is more expensive, but provides more protection. It functions just like a garage. The boat is kept indoors, where it is safe from the elements. You still might want to invest in a boat cover to keep out pests."
			}
		],
	},
];

export { BOAT_STORAGE_DATA };
